import { useId } from 'react'

export const useIdsForFormFields = (): Record<string, string> => {
  return {
    allergiesId: useId(),
    birthdateChildrenId: useId(),
    birthdateId: useId(),
    cityId: useId(),
    deliveryAddressId: useId(),
    emailId: useId(),
    firstnameId: useId(),
    heightId: useId(),
    insuranceNumberId: useId(),
    lastnameId: useId(),
    medicationId: useId(),
    otherConditionsId: useId(),
    phoneId: useId(),
    streetId: useId(),
    streetNoId: useId(),
    weightId: useId(),
    zipId: useId(),
  }
}
